module.exports = __webpack_public_path__ + "image-4b94ad6f909a.png";